/**
 * AuthGate -- Login form component.
 * Handles env toggle, password visibility, and login submission.
 *
 * @module presentation/components/AuthGate
 */

import { AppConfig } from '../../config.js';
import { AuthService } from '../../application/AuthService.js';

export function setupAuthGate(onSuccess) {
  const $form = document.getElementById('nx-auth-form');
  const $email = document.getElementById('nx-auth-email');
  const $pass = document.getElementById('nx-auth-pass');
  const $error = document.getElementById('nx-auth-error');
  const $togglePass = document.getElementById('nx-auth-toggle-pass');
  const $envDev = document.getElementById('btn-env-dev');
  const $envProd = document.getElementById('btn-env-prod');
  const $btnLogin = document.getElementById('btn-login');

  const env = AppConfig.env;
  $envDev.classList.toggle('active', env === 'dev');
  $envProd.classList.toggle('active', env === 'prod');

  $envDev.onclick = () => {
    AppConfig.setEnv('dev');
    $envDev.classList.add('active');
    $envProd.classList.remove('active');
  };

  $envProd.onclick = () => {
    AppConfig.setEnv('prod');
    $envProd.classList.add('active');
    $envDev.classList.remove('active');
  };

  $togglePass.onclick = () => {
    const isPassword = $pass.type === 'password';
    $pass.type = isPassword ? 'text' : 'password';
    $togglePass.innerHTML = isPassword ? '&#128064;' : '&#128065;';
  };

  $form.onsubmit = async (e) => {
    e.preventDefault();
    $error.hidden = true;

    const email = $email.value.trim();
    const password = $pass.value;

    if (!email || !password) {
      showError($error, 'Email y contrasena son requeridos');
      return;
    }

    $btnLogin.disabled = true;
    $btnLogin.textContent = 'Entrando...';

    const result = await AuthService.login(email, password);

    $btnLogin.disabled = false;
    $btnLogin.textContent = 'Entrar';

    if (result.ok) {
      onSuccess();
    } else {
      const msg = result.error?.includes?.('fetch') || result.code === 'NETWORK'
        ? `Error de conexion: ${AppConfig.apiBase || 'proxy'}`
        : result.error;
      showError($error, msg);
    }
  };
}

function showError($el, msg) {
  $el.textContent = msg;
  $el.hidden = false;
}
